module.exports = __webpack_public_path__ + "img/risk-waiting-approval.b1da570d.png";